import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function WebActionVeevaRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const type = searchParams.get("type");

    // copy params and remove `type`
    const params = new URLSearchParams(searchParams);
    params.delete("type");

    let targetPath;

    switch (type) {
      case "1":
        targetPath = "/template-manager";
        break;
      case "2":
        targetPath = "/edetail-manager";
        break;
      default:
        navigate("/edetail-manager");
        return;
    }

    navigate(`${targetPath}?${params.toString()}`, {
      state: { cameFrom: "webaction" },
    });
  }, [navigate, searchParams]);

  return null; // redirect-only component
}
